import { useCallback, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { useExpertReportPeriod } from '@features/expertReports'

import type { PeriodValue } from '../../../types/periodValue'

interface ExpertTrialBalanceParams {
  hideZeroes: boolean
  period: string
  search: string
  setPeriod: (value: PeriodValue) => boolean
  setSearch: (value: string) => void
}

export const useExpertTrialBalanceParams = (): ExpertTrialBalanceParams => {
  const navigate = useNavigate()
  const { pathname, search: locationSearch } = useLocation()
  const { encodedPeriod, setPeriod } = useExpertReportPeriod()

  const { hideZeroes, search } = useMemo(() => {
    const searchParams = new URLSearchParams(locationSearch)

    return {
      hideZeroes: searchParams.get('showZeroBalanceAccounts') !== 'true',
      search: (searchParams.get('search') ?? '').trim(),
    }
  }, [locationSearch])

  const setSearch = useCallback(
    (value: string) => {
      const searchParams = new URLSearchParams(locationSearch)
      const trimmedSearch = value.trim()

      if (trimmedSearch) {
        searchParams.set('search', trimmedSearch)
      } else {
        searchParams.delete('search')
      }

      navigate({ pathname, search: searchParams.toString() }, { replace: true })
    },
    [locationSearch, navigate, pathname],
  )

  return { hideZeroes, period: encodedPeriod, search, setPeriod, setSearch }
}
